let queryParams = {
	get: key=>{
		let searchArr = window.location.search.substr(1).split('&');
		let searchObj = {};
		searchArr.forEach(n=>{
			let splitArr = n.split('=');
			if (splitArr.length === 2) {
				searchObj[splitArr[0]] = splitArr[1];
			}
		})
		return searchObj[key];
	}
}
export default queryParams;


// WEBPACK FOOTER //
// ./src/scripts/data/queryparams.js